module.exports = __webpack_public_path__ + "img/Ubiquiti-UniFi.fbb608d.svg";